// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import LlmModelsController from "./llm_models_controller"
application.register("llm-models", LlmModelsController)

import ProviderFilterController from "./provider_filter_controller"
application.register("provider-filter", ProviderFilterController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import SelectableController from "./selectable_controller"
application.register("selectable", SelectableController)

import SlugController from "./slug_controller"
application.register("slug", SlugController)

import UploadValidatorController from "./upload_validator_controller"
application.register("upload-validator", UploadValidatorController)
